export default {"src":"/_next/static/media/logo-large.bdac1271.svg","height":33,"width":171};